const buildThresholdList = () => {
  let thresholds = [];
  let numSteps = 5;

  for (let i = 1.0; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
};

let iObserver: IntersectionObserver;

const headerMenu = {
  elem: document.querySelector<HTMLDivElement>('.saig-o-header'),
  userLogin: document?.querySelector<HTMLDivElement>('.saig-o-header-menu__sign-in-out'),
  cartDiv: document?.querySelector<HTMLDivElement>('.saig-o-header-menu__mini-cart'),
  swDiv: document?.querySelector<HTMLDivElement>('.saig-o-header-menu__standard-watch-alert'),
  expanded: false,
  media: window.matchMedia('(min-width:1200px)').matches,
  init: function () {
    if (!this.elem) return;

    this.addEvents();
    this.addMenuExpandEvent();
    this.buildCustomListener();
    this.setHeightHeader();
    this.registerIObserver();
    this.registerResizeObserver();
    this.addSetQuotesQuantity();
    this.openLoginSetup();
  },
  addEvents: function () {
    const hamburger = this.elem?.querySelector('.saig-a-hamburger');
    const loginButton = this.elem?.querySelectorAll('.saig-button-user');


    hamburger?.addEventListener('click', this.hamburgerClickHandler.bind(this));
    // loginButton?.addEventListener('click', this.userClickHandler.bind(this));
    [].forEach.call(loginButton, (item: any) => {
      item.addEventListener('click', this.userClickHandler.bind(this));
    });
    document?.addEventListener('click', this.documentClickHandler.bind(this));

    this.addMiniCartClickEvent();
    this.addwAlertClickEvent();

    window.addEventListener('openLogin', (event: any) => {
      this.userClickHandler(event);
    });

    window.addEventListener('openMiniCart', (event: any) => {
      this.cartClickHandler(event);
    });

    window.addEventListener('addMiniCartClickEvent', (event: any) => {
      this.addMiniCartClickEvent();
    });

    window.addEventListener('addwAlertClickEvent', (event: any) => {
      this.addwAlertClickEvent();
    });
  },
  addMiniCartClickEvent: function () {
    this.userLogin = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__sign-in-out');
    this.cartDiv = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__mini-cart');
    this.swDiv = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__standard-watch-alert');
    const cartButton = this.elem?.querySelector('.button-cart');
    cartButton?.addEventListener('click', this.cartClickHandler.bind(this));
  },

  addwAlertClickEvent: function () {
    this.userLogin = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__sign-in-out');
    this.cartDiv = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__mini-cart');
    this.swDiv = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__standard-watch-alert');
    const swButton = this.elem?.querySelector('.saig-button-swalert');
    swButton?.addEventListener('click', this.swAlertClickHandler.bind(this));
  },

  hamburgerClickHandler: function () {
    this.showMenu(!this.expanded);
  },
  userClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();
    if (event.type == 'click') {
      this.userLogin?.classList.contains('show') ? this.userLogin?.classList.remove('show') : this.userLogin?.classList.add('show');
    } else {
      this.userLogin?.classList.contains('show') ? '' : this.userLogin?.classList.add('show');
    }
    this.cartDiv?.classList.remove('show');
    document?.querySelector('body')?.classList.remove('modal-overlay-on');
    this.swDiv?.classList.remove('show');
  },
  swAlertClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();
    if (event.type == 'click') {
      this.swDiv?.classList.contains('show') ? this.swDiv?.classList.remove('show') : this.swDiv?.classList.add('show');
    } else {
      this.swDiv?.classList.contains('show') ? '' : this.swDiv?.classList.add('show');
    }
    this.userLogin?.classList.remove('show');
    this.cartDiv?.classList.remove('show');
  },
  cartClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();

    if (event.type == 'click') {
      if (this.cartDiv?.classList.contains('show')) {
        this.cartDiv?.classList.remove('show');
        document?.querySelector('body')?.classList.remove('modal-overlay-on');
      } else {
        this.cartDiv?.classList.add('show');
        document?.querySelector('body')?.classList.add('modal-overlay-on');
      }
    } else {
      if (this.cartDiv?.classList.contains('show')) { '' } else {
        this.cartDiv?.classList.add('show');
        document?.querySelector('body')?.classList.add('modal-overlay-on');
      }
    }
    this.userLogin?.classList.remove('show');
    this.swDiv?.classList.remove('show');
  },
  documentClickHandler: function (event: any) {
    const cartDiv = this.elem?.querySelector<HTMLDivElement>('.saig-o-header-menu__mini-cart');
    const cartinnerDiv = this.elem?.querySelector<HTMLDivElement>('.saig-o-mini-cart__inner-wrapper');
    const userLogin = this.elem?.querySelector<HTMLDivElement>('.saig-o-header-menu__sign-in-out');
    const swDiv = this.elem?.querySelector<HTMLDivElement>('.saig-o-header-menu__standard-watch-alert');
    const logininnerDiv = this.elem?.querySelector<HTMLDivElement>('.saig-o-sign-in__inner-wrapper');
    const logoutinnerDiv = this.elem?.querySelector<HTMLDivElement>('.saig-o-sign-out__inner-wrapper');
    const target = event.target as HTMLDivElement;
    if (!event.target.matches('.saig-button-user')) {
      if (!logininnerDiv?.contains(target) && !logoutinnerDiv?.contains(target)) {
        userLogin?.classList.remove('show');
      }
    }

    if (!event.target.matches('.button-cart')) {
      if (!cartinnerDiv?.contains(target)) {
        cartDiv?.classList.remove('show');
        document?.querySelector('body')?.classList.remove('modal-overlay-on');
      }
    }

    if (!event.target.matches('.saig-button-swalert')) {
      if (!swDiv?.contains(target)) {
        swDiv?.classList.remove('show');
      }
    }
  },
  showMenu: function (show: boolean) {
    const hamburger = this.elem?.querySelector('.saig-a-hamburger');
    const nav = this.elem?.querySelector('.saig-o-main-menu');
    const mainMenu = this.elem?.querySelector<HTMLDivElement>('.saig-o-header-menu');

    if (show) {
      this.elem?.classList.add('active');
      hamburger?.classList.add('active');
      nav?.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.expanded = true;
    } else {
      this.elem?.classList.remove('active');
      hamburger?.classList.remove('active');
      nav?.classList.remove('active');
      document.body.style.overflow = '';
      mainMenu && mainMenu.style.removeProperty('--height-header');
      this.expanded = false;

      this.closeMenuExpanded();
    }
  },
  addMenuExpandEvent: function () {
    const items = this.elem?.querySelectorAll('.saig-o-main-menu__text');

    [].forEach.call(items, (item: HTMLDivElement) => {
      item.addEventListener('click', this.handleMenuExpand.bind(this));
    });
  },
  handleMenuExpand: function (event: MouseEvent) {
    const currentTarget = event.currentTarget as HTMLDivElement;

    if (currentTarget.parentElement?.classList.contains('expanded')) {
      this.closeMenuExpanded();
    } else {
      this.openMenuExpanded(currentTarget);
    }
  },
  closeMenuExpanded: function () {
    const items = this.elem?.querySelectorAll('.expanded');

    [].forEach.call(items, (item: HTMLDivElement) => {
      item?.classList.remove('expanded');
    });

    // un-listen intersection
    const secondaryHeader = this.elem?.querySelector<HTMLDivElement>('.saig-o-secondary-header');
    secondaryHeader && iObserver && iObserver.unobserve(secondaryHeader);
  },
  openMenuExpanded: function (currentTarget: HTMLDivElement) {
    const mainMenu = currentTarget.closest('.saig-o-main-menu');
    const currentElemExpands = mainMenu?.querySelectorAll('.expanded');
    const topElem = currentTarget.parentElement?.querySelector('.saig-o-main-menu-dropdown__top');

    // close all
    [].forEach.call(currentElemExpands, (elem: HTMLDivElement) => {
      elem.classList.remove('expanded');
    });

    // open current
    currentTarget.parentElement?.classList.add('expanded');
    mainMenu?.classList.add('expanded');
    currentTarget.parentElement?.style.setProperty('--top-height', `${topElem?.clientHeight || 0}px`);

    // listen intersection
    const secondaryHeader = this.elem?.querySelector<HTMLDivElement>('.saig-o-secondary-header');
    secondaryHeader && iObserver && iObserver.observe(secondaryHeader);
  },
  buildCustomListener: function () {
    window.addEventListener('closeExpanded', this.closeMenuExpanded.bind(this));

    window.addEventListener('closeMenu', () => {
      this.showMenu(false);
    });
  },
  setHeightHeader: function () {
    const mainMenu = this.elem?.querySelector<HTMLDivElement>('.saig-o-header-menu');
    const secondaryHeader = this.elem?.querySelector<HTMLDivElement>('.saig-o-secondary-header');
    const isDesktop = window.matchMedia('(min-width:1200px)').matches;

    if (!mainMenu) {
      console.warn('main menu is empty');
      return;
    }

    if (!isDesktop) {
      mainMenu.style.removeProperty('--height-header');
      return;
    }

    let height = mainMenu.clientHeight;

    if (secondaryHeader) {
      height += Math.max(secondaryHeader.getBoundingClientRect().bottom, 0);
    }

    mainMenu.style.setProperty('--height-header', `${height}px`);
    mainMenu.dataset.heightHeader = height + '';
  },
  registerIObserver: function () {
    const isDesktop = window.matchMedia('(min-width:1200px)').matches;

    if (typeof IntersectionObserver === 'undefined') {
      console.warn('very old browser is not support IntersectionObserver');
    }

    if (isDesktop && typeof IntersectionObserver !== 'undefined') {
      iObserver = new IntersectionObserver(this.handleIntersect.bind(this), {
        root: null,
        rootMargin: '0px',
        threshold: buildThresholdList(),
      });
    }
  },
  handleIntersect: function (entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
    this.setHeightHeader();
  },
  registerResizeObserver: function () {
    this.elem?.observeResize(this.handlerResize.bind(this));
  },
  handlerResize: function () {
    const currentMedia = window.matchMedia('(min-width:1200px)').matches;

    if (currentMedia !== this.media) {
      this.media = currentMedia;
      this.showMenu(false);
    }
  },
  addSetQuotesQuantity: function () {
    window.setQuotesQuantity = (amount: number) => {
      if (!this.elem) return;

      const userCounterEl = this.elem.querySelector<HTMLSpanElement>('.saig-button-user .saig-a-button__counter');
      const linkList = this.elem.querySelectorAll<HTMLAnchorElement>('.saig-o-sign-out__menu-item .saig-a-link');
      const quotesLink = [].find.call(linkList, (link: HTMLAnchorElement) => link.textContent?.toLocaleLowerCase().includes('quotes'));

      window.quotesQuantity = amount;

      if (userCounterEl) {
        if (amount) {
          userCounterEl.innerHTML = amount + '';
          userCounterEl.style.display = 'flex';
        } else {
          userCounterEl.innerHTML = amount + '';
          userCounterEl.style.display = 'none';
        }
      }

      if (quotesLink) {
        let quote = quotesLink as HTMLAnchorElement;
        if (amount) {
          quote && (quote.innerHTML = quote.innerText.replace(/\(\d+\)/, `(${amount})`));
        } else {
          quote && (quote.innerHTML = quote.innerText.replace(/\(\d+\)/, ''));
        }
      }
    };
  },

  openLoginSetup: function () {
    const url = new URL(location.href);
    const hash = url.hash;

    if (hash === '#login') {
      window.dispatchEvent(new CustomEvent('openLogin'));
    }
  },
};

headerMenu.init();
